<template>
  <Modal v-model="visible" title="征信信息" :width="70" :footer-hide="true">
    <credit-history-person :actions="actions" :person-id="personId" />
  </Modal>
</template>
<script>
import creditHistoryPerson from '../../../../credit/history/person'
export default {
  components: { creditHistoryPerson },
  data() {
    return {
      visible: false,
      personId: null,
      actions: [{
        title: '操作',
        key: 'action',
        width: 150,
        align: 'center',
        fixed: 'right',
        render: (h, params) => {
          let acts = []

          if (!params.row.orderNo) {
            acts.push(h('a', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  this.bind(params)
                }
              }
            }, '绑定'))
          }
          return h('div', acts)
        }
      }]
    }
  },
  created() {

  },
  methods: {
    init(id) {
      this.visible = true
      this.personId = id
      // this.$refs['chp'].init(id)
    },
    bind(data) {
      this.$emit('on-select', data)
      this.visible = false
    },
  }

}

</script>
